// T73 (Titipan auditor 27 Okt 2026) — SATU sumber label tempat di layar:
//   tabel `regions` (Samarinda, Surabaya)              = WILAYAH
//   tabel `stores`  (Samarinda, Balikpapan, Surabaya)  = CABANG
// Dulu "Cabang" berarti region dan "Store" berarti cabang (WO menulis "Cabang: Samarinda, Store: Balikpapan").
// Kembaran server: backend/services/teks_tampilan.py (LABEL_WILAYAH, LABEL_CABANG, wilayah_cabang).
// Nama peran "Kepala Cabang" TIDAK ikut berubah (nama jabatan resmi). Dijaga pagarIstilahWilayah.test.js.

export const LABEL_WILAYAH = "Wilayah";
export const LABEL_CABANG = "Cabang";

/** ('Samarinda', 'Balikpapan') → 'Wilayah: Samarinda · Cabang: Balikpapan'; tanpa cabang → 'Wilayah: Samarinda'. */
export function teksWilayahCabang(wilayah, cabang) {
  const w = wilayah && String(wilayah).trim() ? String(wilayah).trim() : "—";
  const c = cabang && String(cabang).trim() ? String(cabang).trim() : "";
  return c ? `${LABEL_WILAYAH}: ${w} · ${LABEL_CABANG}: ${c}` : `${LABEL_WILAYAH}: ${w}`;
}
